import BGPH1 from "../../assets/images/backgrounds/page-header-bg-1-1.jpg";
import { Link } from "react-router-dom";
import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${BGPH1})` }}
        ></div>

        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <span>Privacy Policy</span>
            </li>
          </ul>
          <h2>Privacy Policy</h2>
        </div>
      </section>

      <section className="about-two pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="blog-details__content">
                <div className="block-title text-left">
                  <p className="block-title__tagline">Ozrich Finance</p>
                  <h2 className="block-title__title">
                    Your privacy is important
                  </h2>
                </div>
                <p className="mb-20">
                  Ozrich Finance, understands that the details you provide us
                  with are not only private and personal but that how we
                  collect, use, hold, exchange and protect your information is
                  important to you. It's imperative that you feel secure
                  whenever you deal with us. It's also important that you
                  understand how we protect your privacy, as well as how, when
                  and where we may use your personal information. This Privacy
                  Policy is our commitment to you on what our policies towards
                  your privacy are. You can be confident in the fact that we
                  abide by and are bound by the Privacy Act and the Australian
                  Privacy Principles (APPs) for the protection of personal
                  information.
                </p>

                <h3 className="mt-40 mb-20">What information do we collect?</h3>
                <p className="mb-20">
                  We collect personal information. Personal information means
                  any information or opinion about you as an identified
                  individual, or an individual who is reasonably identifiable,
                  whether the information or opinion is true or not, and whether
                  the information or opinion is recorded in a material form or
                  not. For example identity and contact details, marital status
                  and financial information. We may also collect sensitive
                  information for specific purposes. For example, information
                  about your health to enable the credit provider to assess an
                  application you make for mortgage protection insurance and
                  calculate any premiums. If we need this type of information,
                  we will ask for your consent.
                </p>

                <h3 className="mt-40 mb-20">
                  How do we collect your personal information?
                </h3>
                <p className="mb-20">
                  We will always aim to collect your personal information
                  directly from you. If for some good reason, we are unable to
                  do so, we may involve another organisation. For example, we
                  may need to request a credit report from a credit reporting
                  body when you apply for a credit facility. Before doing so or
                  prior to collecting the information we need, we will inform
                  you of the type of organisations we intend to disclose your
                  personal information to. We may also collect your personal
                  information through third parties who undertake the collection
                  on our behalf.
                </p>

                <h3 className="mt-40 mb-20">
                  Why do we collect your personal information?
                </h3>
                <p className="mb-20">
                  We collect and receive personal information directly from you
                  or from other business referrers in order to conduct our
                  business so that we can:
                </p>
                <ul className="list-unstyled ml-0 about-two__list mb-20">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>submit your
                    application for credit to a supplier via our Aggregator
                    partner National Mortgage Brokers Pty Ltd;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>identify and
                    tell you via direct marketing communications about other
                    products or services offered by us or a third party that may
                    interest you (unless you tell us not to);
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>administer our
                    customer relationships;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>for internal
                    purposes, including for reporting and analytical purposes;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>meet our legal
                    and regulatory reporting obligations;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>establish a
                    customer marketing program;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>system
                    development testing purposes;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>ensure your
                    security when visiting our website and to learn which areas
                    of the site are of most interest to you (see the section
                    'cookies' below); and
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>any other
                    purpose related to the above.
                  </li>
                </ul>

                <h3 className="mt-40 mb-20">Direct Marketing</h3>
                <p className="mb-20">
                  As stated above, we may use the information we gather to
                  provide you with targeted communications about products and
                  services we think will be of interest to you. We may also send
                  you details of offers or services provided by our business
                  partners and related entities. These direct marketing offers
                  and promotions are designed to make your life easier, not
                  harder.
                </p>
                <p className="mb-20">
                  You may at any time choose not to receive these
                  communications. Doing so will not cost you anything, and we
                  commit to ensure you stop receiving any unwanted
                  communications as soon as possible. If you do not want to
                  receive such marketing communications, please write to us at
                  the following address:
                </p>
                <p className="mb-20">
                  The Privacy Officer at:
                  <br />
                  Ozrich Finance,
                  <br />
                  8 Khalil Avenue,
                  <br />
                  Dandenong North, VIC 3175.
                </p>
                <p className="mb-20">
                  or email the Privacy Officer at{" "}
                  <a href="mailto:ksenarathna@ozrichfinance.com.au">
                    ksenarathna@ozrichfinance.com.au
                  </a>
                </p>

                <h3 className="mt-40 mb-20">
                  Why do we exchange your information with another organisation?
                </h3>
                <p className="mb-20">
                  As a Mortgage Broker, we aim to provide you with products and
                  services which suit your requirements. That means we partner
                  with other organisations who provide and support the products
                  and services we offer. In order to submit your application to
                  a supplier for consideration, we will need to provide such
                  supplier with your personal information that we hold.
                </p>
                <p className="mb-20">
                  As you will appreciate, in certain circumstances we may be
                  compelled by law to disclose your personal information to
                  various authorities. For instance, we may be required under
                  the Anti-Money Laundering and Counter-Terrorism Financing Act
                  to disclose details of financial transactions and we may also
                  be compelled under tax laws to provide such information to
                  regulators.
                </p>
                <p className="mb-20">
                  Other organisations which we may exchange your personal
                  information with may include:
                </p>
                <ul className="list-unstyled ml-0 about-two__list mb-20">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>credit
                    providers;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>credit reporting
                    bodies;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>government and
                    law enforcement agencies;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>our suppliers,
                    associates, service providers or contractors (including, for
                    example, call centre, stationery printing houses, mail
                    houses, information technology, marketing agencies, and
                    marketing research companies etc);
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>any person who
                    proposes to guarantee or has guaranteed repayment of any
                    credit provided to you;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>mortgage
                    insurers, brokers, originators and/or managers, financial
                    consultants, accountants, lawyers or real estate agents;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>National
                    Mortgage Brokers Pty. Ltd., our aggregator partner;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>those in
                    connection with funding financial accommodation by means of
                    an arrangement involving securitisation;
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>third parties to
                    enable them to contact you to offer their products and
                    services or to determine if you would be interested in the
                    products and services; and
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>any person
                    considering acquiring or taking an interest in our business.
                  </li>
                </ul>
                <p className="" style={{ marginTop: "20px" }}>
                  This is to your benefit, and helps us to provide the products
                  and services you would expect from Ozrich Finance.
                </p>
                <p
                  className=""
                  style={{ marginTop: "5px", marginBottom: "-10px" }}
                >
                  Before we disclose any of your personal information to any
                  other organisation, we will take reasonable steps to ensure
                  that:
                </p>
                <ul className="list-unstyled ml-0 about-two__list mb-20">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>The organisation
                    has the same commitment as us to the protection of your
                    personal information; AND
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>You have
                    consented to us doing so.
                  </li>
                </ul>
                <p className="mb-20" style={{ marginTop: "20px" }}>
                  By consent, we mean approval in writing, orally, or implied
                  from your dealings with us.
                </p>

                <h3 className="mt-40 mb-20">
                  Disclosure of personal information overseas
                </h3>
                <p className="mb-20">
                  We may hold or process your information on servers located
                  overseas for filtering, hosting or storage purposes, reporting
                  and analytical purposes and for system development testing
                  purposes. If we do this, we make sure that such organisations
                  have the appropriate data handling and security arrangements
                  in place to ensure compliance with this Privacy Policy.
                  Australia's Privacy Act may not apply to such overseas
                  organisations.
                </p>

                <h3 className="mt-50 mb-20">
                  Access to and correction of your personal information
                </h3>
                <p className="mb-20">
                  It is important for us, and for you, that the information we
                  hold is accurate and up to date. In this, we rely on you to
                  help us. We ask that you contact us whenever there are any
                  changes to your personal information, so that we can update
                  our records. The personal information we hold about you is
                  yours to access and correct, and as such we can provide you
                  with general information, such as your name, address and
                  contact details quite easily. There is no fee for making the
                  initial request. More detailed information may not be as easy
                  for us to access, and if necessary, in some cases there may be
                  an access charge to cover the time we spend locating,
                  compiling and explaining the information you ask for. If there
                  is an access charge, we'll give you an estimate up front and
                  confirm that you'd like us to proceed. Generally, the access
                  charge is based on an hourly rate plus any photocopying costs
                  or other out-of-pocket expenses. You'll need to make the
                  payment before we start.
                </p>
                <p className="mb-20">
                  The process of providing you with access to or correcting your
                  personal information may take up to 30 working days from the
                  date of your request. If we refuse to give you access to or
                  correct your information, we must give you written notice
                  setting out the reasons for the refusal and the mechanisms
                  available for you to complain about the refusal.
                </p>
                <p className="mb-20">
                  If you need to access or correct your detailed information,
                  just write to us at the following address:
                </p>
                <p className="mb-20">
                  The Privacy Officer at:
                  <br />
                  Ozrich Finance,
                  <br />
                  8 Khalil Avenue,
                  <br />
                  Dandenong North, VIC 3175.
                </p>
                <p className="mb-20">
                  or email the Privacy Officer at{" "}
                  <a href="mailto:ksenarathna@ozrichfinance.com.au">
                    ksenarathna@ozrichfinance.com.au
                  </a>
                </p>

                <h3 className="mt-50 mb-20">
                  Security and storage of your personal information
                </h3>
                <h4 className="mt-30 mb-20">
                  How long do we keep information about you?
                </h4>
                <p className="mb-20">
                  By law, we are required to hold certain information about you,
                  even after you are no longer a customer. We may also hold
                  certain information about you if it is needed for a purpose
                  which you are aware of or reasonably expect us to hold the
                  information. When your information is no longer needed or
                  required to be held by law, it will be destroyed or
                  de-identified.
                </p>
                <h4 className="mt-30 mb-20">
                  How safe and secure is the information we hold about you?
                </h4>
                <p className="mb-20">
                  We will take great care to protect your personal information
                  by storing it in a secure environment, and when the
                  information is no longer needed for any purpose for which the
                  information may be used or disclosed, it will be destroyed or
                  permanently de-identified. We will also take reasonable steps
                  to protect any personal information from misuse, loss and
                  unauthorized access, modification or disclosure.
                </p>

                <h3 className="mt-50 mb-20">Online security</h3>
                <p className="mb-20">
                  Our website uses encryption techniques to enhance your privacy
                  and security when using Ozrich Finance website.
                </p>

                <h3 className="mt-50 mb-20">
                  What are 'cookies' and how do they work?
                </h3>
                <p className="mb-20">
                  Cookies are small data files that are downloaded from our web
                  servers, and stored on your hard drive. A cookie is a string
                  of letters and numbers that uniquely identify the computer you
                  are using, and the customer number and access code you may
                  have used to register at the site. Cookies are used on the
                  Ozrich Finance web site. We track a visitor's journey through
                  our site. This allows us to see at a glance which pages and
                  information is of most interest to visitors. This type of
                  cookie contains no personal information at all; simply a
                  record of your journey through the site. Most browsers can be
                  configured to refuse to accept cookies. You can also delete
                  cookies form your hard drive. However, doing so may hinder
                  your access to valuable areas of information within our site.
                </p>

                <h3 className="mt-50 mb-20">If you have a privacy complaint</h3>
                <p className="mb-20">
                  Ozrich Finance values our customers. We will always aim to be
                  fair and responsive. If you have a complaint, including a
                  complaint about Ozrich Finance's compliance with the APPs, you
                  have the right to expect that we will handle it in a friendly
                  and professional way. When we receive a complaint, we look on
                  it as valuable feedback that may help us to improve the
                  services we offer and to ensure your needs are met in a
                  satisfactory and appropriate manner. If you wish to complain,
                  at any time, about the handling, use or disclosure of your
                  personal information, or about Ozrich Finance's compliance
                  with the APPs, just write to us at the following address:
                </p>
                <p className="mb-20">
                  The Privacy Officer at:
                  <br />
                  Ozrich Finance,
                  <br />
                  8 Khalil Avenue,
                  <br />
                  Dandenong North, VIC 3175.
                </p>
                <p className="mb-20">
                  or email the Privacy Officer at{" "}
                  <a href="mailto:ksenarathna@ozrichfinance.com.au">
                    ksenarathna@ozrichfinance.com.au
                  </a>
                </p>
                <p className="mb-20">
                  We will make all efforts possible to investigate your
                  complaint, and advise you of the outcome as soon as possible.
                  If the matter is not resolved to your satisfaction, you can
                  then refer your complaint to the Australian Information
                  Commissioner, who can be contacted at:
                </p>
                <p className="mb-20">
                  Office of the Australian Information Commissioner (OAIC)
                  <br />
                  Level 3
                  <br />
                  175 Pitt Street
                  <br />
                  Sydney NSW 2000
                </p>

                <h3 className="mt-50 mb-20">More information</h3>
                <p className="mb-20">
                  You can request further information about the way we manage
                  the personal information that we hold by writing to:
                </p>
                <p className="mb-20">
                  The Privacy Officer at:
                  <br />
                  Ozrich Finance,
                  <br />
                  8 Khalil Avenue,
                  <br />
                  Dandenong North, VIC 3175.
                </p>
                <p className="mb-20">
                  or email the Privacy Officer at{" "}
                  <a href="mailto:ksenarathna@ozrichfinance.com.au">
                    ksenarathna@ozrichfinance.com.au
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Link
        to="#"
        data-target="html"
        className="scroll-to-target scroll-to-top"
      >
        <i className="fa fa-angle-up"></i>
      </Link>
    </>
  );
};

export default PrivacyPolicy;
